export class NotificationRulesMetadataIds {
  constructor() {
    this.clientIds = [];
    this.processNodeIds = [];
    this.organizationIds = [];
  }

  clientIds: number[];
  processNodeIds: string[];
  organizationIds: number[];
}
